import React, { useEffect, useState } from 'react';
import {
  ModalBody,
  Text,
  Flex,
  Button,
  Tab,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Spinner,
  Center,
} from '@chakra-ui/react';
import VehicleInfo from './VehicleInfo';
import VehicleClients from './VehicleClients';
import ServiceDetails from './ServiceDetails';
import { getData } from '../../../utils/httpClient';

const VehicleDetailModal = ({ vehicleData, onClose }) => {
  const [fullVehicle, setFullVehicle] = useState(vehicleData);
  const [loading, setLoading] = useState(Boolean(vehicleData?.id));

  useEffect(() => {
    if (!vehicleData?.id) {
      setFullVehicle(vehicleData);
      setLoading(false);
      return;
    }

    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const response = await getData(`/vehicles/${vehicleData.id}`, {
          skipLoader: true,
        });
        if (!cancelled) {
          setFullVehicle(response?.payload?.vehicle || vehicleData);
        }
      } catch {
        if (!cancelled) {
          setFullVehicle(vehicleData);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [vehicleData?.id]);

  if (loading) {
    return (
      <ModalBody>
        <Center py={10}>
          <Spinner size="lg" />
          <Text ml={3}>Cargando historial del vehículo...</Text>
        </Center>
      </ModalBody>
    );
  }

  return (
    <>
      <ModalBody>
        <Flex direction="column" p="4">
          <Text fontSize="lg" fontWeight="bold">
            Detalles del Vehículo
          </Text>
          <Tabs mt="4" variant="enclosed">
            <TabList>
              <Tab>Información General</Tab>
              <Tab>
                Servicios ({fullVehicle?.vehicleServices?.length || 0})
              </Tab>
              <Tab>
                Historial de Clientes (
                {fullVehicle?.vehicleCustomerHistories?.length || 0})
              </Tab>
            </TabList>

            <TabPanels>
              <TabPanel>
                <VehicleInfo vehicleData={fullVehicle} />
              </TabPanel>

              <TabPanel>
                <ServiceDetails services={fullVehicle?.vehicleServices} />
              </TabPanel>
              <TabPanel>
                <VehicleClients
                  vehicleCustomerHistories={
                    fullVehicle?.vehicleCustomerHistories
                  }
                />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Flex>
        <Button mt={4} onClick={onClose}>
          Cerrar
        </Button>
      </ModalBody>
    </>
  );
};

export default VehicleDetailModal;
